import { render, staticRenderFns } from "./ProspectAlerte.vue?vue&type=template&id=5b63338a"
import script from "./ProspectAlerte.vue?vue&type=script&lang=ts"
export * from "./ProspectAlerte.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports